export const BLOG_ARTICLES = [
  {
    slug: 'complete-guide-sports-software',
    title: 'The Complete Guide to Sports Program Management Software in 2026',
    description:
      'Everything you need to know about choosing and implementing sports management software for your program. Learn about key features, benefits, and how to make the right choice.',
    category: 'guides',
    keywords: [
      'sports management software',
      'program management software',
      'class registration software',
      'sports software guide',
      'sports program management',
      'youth sports software'
    ],
    datePublished: '2026-01-26',
    dateModified: '2026-01-26',
    readTime: '10 min',
    featured: true
  },
  {
    slug: 'online-registration-benefits',
    title: 'How Online Registration Increases Enrollment by 40%',
    description:
      'Discover how sports programs are dramatically increasing enrollment with online registration systems. Real data and strategies you can implement today.',
    category: 'growth',
    keywords: [
      'online registration',
      'class registration system',
      'increase enrollment',
      'sports registration',
      'registration software',
      'enrollment strategies'
    ],
    datePublished: '2026-01-26',
    dateModified: '2026-01-26',
    readTime: '7 min',
    featured: true
  },
  {
    slug: 'skill-tracking-youth-sports',
    title: 'Skill Tracking for Youth Sports: The Ultimate Guide',
    description:
      'Learn how skill tracking software helps coaches develop athletes and keeps parents engaged. A comprehensive guide to implementing skill progression in your program.',
    category: 'guides',
    keywords: [
      'skill tracking software',
      'youth sports development',
      'athlete progress tracking',
      'skill progression',
      'coaching software',
      'player development'
    ],
    datePublished: '2026-01-26',
    dateModified: '2026-01-26',
    readTime: '8 min',
    featured: true
  },
  {
    slug: 'ice-skating-program-management',
    title: 'Ice Skating Program Management: From Beginner Classes to Competitions',
    description:
      'A complete guide to managing ice skating programs efficiently. Learn about LTS USA curriculum support, skill tracking, and growing your skating program.',
    category: 'sports',
    sport: 'ice-skating',
    keywords: [
      'ice skating software',
      'figure skating management',
      'skating rink software',
      'LTS USA software',
      'learn to skate program',
      'skating class management'
    ],
    datePublished: '2026-01-26',
    dateModified: '2026-01-26',
    readTime: '9 min',
    featured: false
  },
  {
    slug: 'gymnastics-class-software-guide',
    title: 'Gymnastics Class Software: Managing Levels, Skills, and Registrations',
    description:
      'How to choose and implement gymnastics management software. Covers skill tracking, class scheduling, and growing your gymnastics program.',
    category: 'sports',
    sport: 'gymnastics',
    keywords: [
      'gymnastics software',
      'gymnastics class management',
      'gym management software',
      'gymnastics registration',
      'gymnastics skill tracking',
      'gymnastics program'
    ],
    datePublished: '2026-01-26',
    dateModified: '2026-01-26',
    readTime: '8 min',
    featured: false
  },
  {
    slug: 'swimming-lesson-management',
    title: 'Swimming Lesson Management Software: What Every Swim School Needs',
    description:
      'Essential features for swim school software and how to choose the right system for your aquatic program. Includes safety, scheduling, and parent communication.',
    category: 'sports',
    sport: 'swimming',
    keywords: [
      'swim school software',
      'swimming lesson management',
      'swim lesson registration',
      'aquatic program software',
      'swim instructor software',
      'pool management'
    ],
    datePublished: '2026-01-26',
    dateModified: '2026-01-26',
    readTime: '8 min',
    featured: false
  },
  {
    slug: 'dance-studio-software',
    title: 'Dance Studio Software: Streamline Your Dance Program Operations',
    description:
      'How dance studio software transforms operations from registration to recitals. Learn about class management, billing, and keeping dance families happy.',
    category: 'sports',
    sport: 'dance',
    keywords: [
      'dance studio software',
      'dance class management',
      'dance school registration',
      'dance studio billing',
      'recital management',
      'dance program software'
    ],
    datePublished: '2026-01-26',
    dateModified: '2026-01-26',
    readTime: '7 min',
    featured: false
  },
  {
    slug: 'martial-arts-school-management',
    title: 'Martial Arts School Management: Belt Tracking and Class Scheduling',
    description:
      'Complete guide to martial arts dojo software. Learn about belt rank tracking, automated billing, and growing your martial arts school.',
    category: 'sports',
    sport: 'martial-arts',
    keywords: [
      'martial arts software',
      'dojo management software',
      'belt tracking software',
      'karate school software',
      'martial arts billing',
      'taekwondo management'
    ],
    datePublished: '2026-01-26',
    dateModified: '2026-01-26',
    readTime: '8 min',
    featured: false
  },
  {
    slug: 'signs-program-needs-software',
    title: '5 Signs Your Sports Program Needs Better Software',
    description:
      'Is your sports program struggling with spreadsheets and manual processes? Here are the warning signs that it is time to upgrade to dedicated sports management software.',
    category: 'business',
    keywords: [
      'sports program software',
      'when to upgrade software',
      'sports management challenges',
      'program management problems',
      'software upgrade signs',
      'sports administration'
    ],
    datePublished: '2026-01-26',
    dateModified: '2026-01-26',
    readTime: '6 min',
    featured: false
  },
  {
    slug: 'choosing-registration-system',
    title: 'How to Choose the Right Class Registration System',
    description:
      'A step-by-step guide to evaluating and selecting class registration software for your sports program. Includes must-have features and questions to ask vendors.',
    category: 'guides',
    keywords: [
      'class registration system',
      'registration software comparison',
      'choosing software',
      'class management software',
      'registration platform',
      'software evaluation'
    ],
    datePublished: '2026-01-26',
    dateModified: '2026-01-26',
    readTime: '9 min',
    featured: false
  },
  {
    slug: 'parent-communication-best-practices',
    title: 'Parent Communication Best Practices for Sports Programs',
    description:
      'How to keep sports families informed and engaged without overwhelming them. Communication strategies that build trust and reduce questions.',
    category: 'tips',
    keywords: [
      'parent communication',
      'sports program communication',
      'family engagement',
      'parent portal',
      'communication strategies',
      'sports notifications'
    ],
    datePublished: '2026-01-26',
    dateModified: '2026-01-26',
    readTime: '6 min',
    featured: false
  },
  {
    slug: 'managing-seasonal-registrations',
    title: 'Managing Seasonal Registrations Without the Chaos',
    description:
      'Strategies for handling registration rushes, waitlists, and session transitions. Make your seasonal registration periods stress-free.',
    category: 'tips',
    keywords: [
      'seasonal registration',
      'registration management',
      'waitlist management',
      'session transitions',
      'registration periods',
      'enrollment management'
    ],
    datePublished: '2026-01-26',
    dateModified: '2026-01-26',
    readTime: '7 min',
    featured: false
  },
  {
    slug: 'scaling-sports-program',
    title: 'How to Scale Your Sports Program from 50 to 500 Students',
    description:
      'Practical strategies for growing your sports program while maintaining quality. Learn about systems, staffing, and technology that enable growth.',
    category: 'growth',
    keywords: [
      'grow sports program',
      'scale sports business',
      'program growth strategies',
      'sports business growth',
      'expand sports program',
      'program scalability'
    ],
    datePublished: '2026-01-26',
    dateModified: '2026-01-26',
    readTime: '10 min',
    featured: false
  },
  {
    slug: 'sports-software-roi',
    title: 'The ROI of Sports Management Software: A Business Case',
    description:
      'Calculate the return on investment of sports program software. Real numbers on time savings, increased enrollment, and reduced administrative costs.',
    category: 'business',
    keywords: [
      'sports software ROI',
      'software investment',
      'program efficiency',
      'cost savings',
      'sports business case',
      'software value'
    ],
    datePublished: '2026-01-26',
    dateModified: '2026-01-26',
    readTime: '8 min',
    featured: false
  }
]

export function getArticleBySlug(slug) {
  return BLOG_ARTICLES.find((article) => article.slug === slug) || null
}

export function getAllArticles() {
  return BLOG_ARTICLES
}

export function getFeaturedArticles() {
  return BLOG_ARTICLES.filter((article) => article.featured)
}

export function getArticlesByCategory(category) {
  return BLOG_ARTICLES.filter((article) => article.category === category)
}

export function getArticleSlugs() {
  return BLOG_ARTICLES.map((article) => article.slug)
}

export function getRelatedArticles(currentSlug, limit = 3) {
  const current = getArticleBySlug(currentSlug)
  if (!current) return []

  return BLOG_ARTICLES.filter((article) => article.slug !== currentSlug && article.category === current.category).slice(
    0,
    limit
  )
}
